/**
 * 销售排行配置
 * 表头/表格字段固化在本地，抽离为独立文件，避免源码修改
 */

import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'SALES_RANKING'
export const REPORT_TITLE = '销售排行'

// 表格列定义
export const defColumns = [
  {
    title: '序号',
    dataIndex: 'rowIndex',
    width: 60,
    align: 'center',
    customRender: function (t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  { title: '商品名称', dataIndex: 'mName', width: 160, ellipsis: true },
  { title: '商品规格', dataIndex: 'standard', width: 120, ellipsis: true },
  { title: '商品类型', dataIndex: 'categoryName', width: 120, ellipsis: true },
  { title: '销售数量', dataIndex: 'numSum', width: 100, align: 'right' },
  { title: '销售金额', dataIndex: 'priceSum', width: 100, align: 'right' }
]

// 排序选项
export const sortOptions = [
  { label: '按销售数量降序', value: 'quantity_desc' },
  { label: '按销售数量升序', value: 'quantity_asc' },
  { label: '按销售金额降序', value: 'amount_desc' },
  { label: '按销售金额升序', value: 'amount_asc' }
]

// 导出配置
export const exportHead = '序号,商品名称,商品规格,商品类型,销售数量,销售金额'
export const exportFields = ['rowIndex', 'mName', 'standard', 'categoryName', 'numSum', 'priceSum']

// 打印数据映射 - 将查询条件转换为打印字段
export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  const rows = (dataSource || []).map((item, idx) => ({
    rowIndex: idx + 1,
    mName: item.mName || '',
    standard: item.standard || '',
    categoryName: item.categoryName || '',
    numSum: item.numSum || 0,
    priceSum: item.priceSum || 0
  }))

  return {
    // 单据主体 — 字段名与模板 BILL_CONFIGS.SALES_RANKING headerGroup 绑定
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    operatorName: (queryParam && queryParam.operatorName) || '',
    customerName: (queryParam && queryParam.customerName) || '',
    depotName: (queryParam && queryParam.depotName) || '',
    categoryName: (queryParam && queryParam.categoryName) || '',
    dateRange: (queryParam && queryParam.beginTime && queryParam.endTime)
      ? queryParam.beginTime + ' ~ ' + queryParam.endTime : '',
    sortBy: (queryParam && queryParam.sortByLabel) || '',
    creatorName: getLoginName(),
    // 单据明细 — 字段名 table 与 createTableElement 的 field: "table" 绑定
    table: rows,
    // 公司信息 / 其它信息
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}